import React, { useState } from 'react';

import { Image, Text, useTheme } from "@aws-amplify/ui-react";
import CELLogo from '../../assets/images/cel-logo.png'

import { updateHeaders } from "../../services/AuthService";
import { Auth } from 'aws-amplify';

export function Header() {
  const { tokens } = useTheme();
  const [isSignedIn, setSignedIn] = useState(false)

  Auth.currentUserInfo().then(response => {
      setSignedIn(response != null)

      Auth.currentSession().then(session =>
      {
        let groups = session.accessToken.payload["cognito:groups"]

        if(!groups.includes("admin"))
          window.location.replace('http://customer.communityenergylabs.com')
        else {
          updateHeaders(session);
        }
      })
  })

  return isSignedIn == null || isSignedIn ?  null : (
    <div style={{width: "100%", textAlign: "center"}}>
          <Image
            style={{maxHeight: 200}}
            alt="logo"
            src={CELLogo}
            padding={tokens.space.small}
          />
    </div>
  );
}
